// @flow strict

import type { RestaurantDatesInfoRecord, RestaurantDatesDefaultRecord } from './records';

class RestaurantsAccumulator {
  today: Date = new Date();
  date: null | Date = null;

  RD(record: RestaurantDatesInfoRecord) {
    this.validateAndRecordDate(record.date);
  }
  RDD(record: RestaurantDatesDefaultRecord) {
    this.validateAndRecordDate(record.date);
  }

  validateAndRecordDate(date: null | Date) {
    if (date === null || date < this.today) {
      this.date = this.today;
      return;
    }
    this.date = date;
  }
}

export default RestaurantsAccumulator;
